import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from "@angular/core";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {ModalComponent} from "@pb-labs/modal";
import {ButtonType} from "@pb-labs/button";
import {fileUploadModalActions} from "../const";
import {FileUploadModalLayoutService} from "@app/modules/browse/components/shared/file-upload-modal/layout/file-upload-modal-layout.service";

@Component({
  selector: "app-file-upload-modal-layout",
  templateUrl: "./file-upload-modal-layout.component.html",
  styleUrls: ["./file-upload-modal-layout.component.scss"],
})
export class FileUploadModalLayoutComponent implements OnInit, OnDestroy {
  @ViewChild("modal") modal: ModalComponent;

  @Input() title = "Upload File";
  @Input() isUploadButtonBusy: boolean;
  @Input() isUploadButtonDisabled: boolean;
  @Input() isCancelButtonDisabled: boolean;
  @Input() isCloseIconDisabled: boolean;
  @Input() isFileUploading: boolean;
  @Output() actionButtonClick: EventEmitter<fileUploadModalActions> = new EventEmitter<fileUploadModalActions>();
  @Output() closeIconClick: EventEmitter<fileUploadModalActions> = new EventEmitter<fileUploadModalActions>();
  readonly fileUploadModalActions = fileUploadModalActions;
  readonly buttonType = ButtonType;
  private _destroy$: Subject<void> = new Subject<void>();

  constructor(private fileUploadModalLayoutService: FileUploadModalLayoutService) {}

  ngOnInit(): void {
    this.fileUploadModalLayoutService.open$.pipe(takeUntil(this._destroy$)).subscribe(() => {
      this.modal.open();
    });

    this.fileUploadModalLayoutService.close$.subscribe(() => {
      this.modal.close();
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  onButtonClick(action: fileUploadModalActions): void {
    this.actionButtonClick.emit(action);
  }

  onCloseIconClick(): void {
    this.closeIconClick.emit();
  }
}
